import React from 'react';

import { resolveBonusCardStatus } from '@atlas/components';
import { Label } from '@atlas/ui';

import useFormatter from 'src/hooks/useFormatter';

import { useBonusDetailContext } from './BonusDetailContext';

const BonusDetailWager = () => {
  const { entity, loading } = useBonusDetailContext();
  const { currencyFormatter } = useFormatter(entity?.currency);

  const { actionGroup } = resolveBonusCardStatus(entity?.status);
  const totalWagerAmount = entity?.wager?.totalAmount ?? 0;

  const wagerMultiplier = entity?.wager?.multiplier ?? 0;
  const wageredAmount = entity?.wager?.wageredAmount ?? 0;
  const percent = Math.min(100, Math.floor((wageredAmount / totalWagerAmount) * 100));

  if (actionGroup !== 'activated' || totalWagerAmount <= 0 || loading) return null;

  return (
    <section className="bonus-details__wager panel">
      <div className="bonus-details__wager-header">
        <Label className="bonus-details__wager-title" message="wagering" />
        <span className="bonus-details__wager-multiplier">x{wagerMultiplier}</span>
      </div>

      <progress className="bonus-details__wager-bar" max={totalWagerAmount} value={wageredAmount} />

      <div className="bonus-details__wager-stats">
        <span className="bonus-details__wager-percent">{percent}%</span>
        <span className="bonus-details__wager-values">
          <span className="bonus-details__wager-current">
            {currencyFormatter.format(wageredAmount)}
          </span>{' '}
          <span className="bonus-details__wager-separator">/</span>{' '}
          {currencyFormatter.format(totalWagerAmount)}
        </span>
      </div>
    </section>
  );
};

export default BonusDetailWager;
